import { DataTransfer } from '@esmiley/frontend-core';
import { CreateLabel, LabelActions, LabelActionTypes, LabelsState } from './types';
import { ErrorActions } from 'redux/ducks/error';
import { ThunkResult } from 'redux/types';
import { AxiosResponse } from 'axios';
import { Label } from 'redux/ducks/data/registrationPoints';
import { IPatchObject } from 'redux/ducks/data/registrations';

export * from './types';

const transfer = new DataTransfer({ retryConfig: { retries: 3 } });

export const initialState: LabelsState = {
  labels: [],
  loading: false
};

export default function reducer(
  state: LabelsState = initialState,
  action: LabelActions
): LabelsState {
  switch (action.type) {
    case LabelActionTypes.LABELS_REQUEST: {
      return { ...state, loading: true };
    }
    case LabelActionTypes.LABELS_FAILURE: {
      return { ...state, loading: false };
    }
    case LabelActionTypes.FIND_LABELS_SUCCESS: {
      return { ...state, labels: action.payload, loading: false };
    }
    case LabelActionTypes.CREATE_LABEL_SUCCESS: {
      return { ...state, labels: [...state.labels, action.payload], loading: false };
    }
    case LabelActionTypes.UPDATE_LABEL_SUCCESS: {
      const updatedLabels = state.labels.map((label) => {
        if (label.id === action.payload.id) {
          return action.payload;
        }
        return label;
      });
      return { ...state, labels: updatedLabels, loading: false };
    }
    case LabelActionTypes.DELETE_LABEL_SUCCESS: {
      const { id } = action.payload;
      return { ...state, labels: state.labels.filter((label) => label.id !== id), loading: false };
    }
    default: {
      return state;
    }
  }
}

export function getLabels(): ThunkResult<
  Promise<LabelActions | ErrorActions>,
  LabelActions | ErrorActions
> {
  return async (dispatch) => {
    dispatch({ type: LabelActionTypes.LABELS_REQUEST });
    try {
      const response = (await transfer.get(`/foodwaste/labels`)) as AxiosResponse<Label[]>;

      return dispatch({
        type: LabelActionTypes.FIND_LABELS_SUCCESS,
        payload: response.data
      });
    } catch {
      return dispatch({
        type: LabelActionTypes.LABELS_FAILURE
      });
    }
  };
}

export function createLabel(
  label: CreateLabel
): ThunkResult<Promise<LabelActions | ErrorActions>, LabelActions | ErrorActions> {
  return async (dispatch) => {
    dispatch({ type: LabelActionTypes.LABELS_REQUEST });
    try {
      const response = (await transfer.post(`/foodwaste/labels`, label)) as AxiosResponse<Label>;

      return dispatch({
        type: LabelActionTypes.CREATE_LABEL_SUCCESS,
        payload: response.data
      });
    } catch {
      return dispatch({
        type: LabelActionTypes.LABELS_FAILURE
      });
    }
  };
}

export function updateLabel(
  labelId: string,
  patchObject: IPatchObject[]
): ThunkResult<Promise<LabelActions | ErrorActions>, LabelActions | ErrorActions> {
  return async (dispatch) => {
    dispatch({
      type: LabelActionTypes.LABELS_REQUEST
    });

    try {
      const response = (await transfer.patch(
        `/foodwaste/labels/${labelId}`,
        patchObject
      )) as AxiosResponse<Label>;
      return dispatch({
        type: LabelActionTypes.UPDATE_LABEL_SUCCESS,
        payload: response.data
      });
    } catch {
      return dispatch({
        type: LabelActionTypes.LABELS_FAILURE
      });
    }
  };
}

export function deleteLabel(
  id: string
): ThunkResult<Promise<LabelActions | ErrorActions>, LabelActions | ErrorActions> {
  return async (dispatch) => {
    dispatch({
      type: LabelActionTypes.LABELS_REQUEST
    });

    try {
      const response = (await transfer.delete(`/foodwaste/labels/${id}`)) as AxiosResponse<Label>;
      return dispatch({
        type: LabelActionTypes.DELETE_LABEL_SUCCESS,
        payload: response.data
      });
    } catch {
      return dispatch({
        type: LabelActionTypes.LABELS_FAILURE
      });
    }
  };
}
